import * as React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { AppBar, Dialog, DialogActions, DialogContent, IconButton, Toolbar, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Project from 'benchmarking-domain/project';
import ProjectSection from 'benchmarking-domain/project-section';
import { QuestionnaireSection } from 'benchmarking-domain/questionnaire';

import KpiViewerForSection from './kpi-viewer/kpi-viewer-for-section';

interface ProjectSectionKpiButtonProps {
  questionnaireSection: QuestionnaireSection;
  project: Project;
  projectSections: ProjectSection[] | undefined;
}

const KpiViewerForSectionMemo = React.memo(KpiViewerForSection);

export function ProjectSectionKpiButton({
  questionnaireSection,
  project,
  projectSections,
}: ProjectSectionKpiButtonProps): React.JSX.Element {
  const [displayKpiViewer, setDisplayKpiViewer] = React.useState<boolean>(false);
  const handleCloseKpiViewer = () => setDisplayKpiViewer(false);

  return (
    <>
      <Button variant="outlined" sx={{ width: 'fit-content' }} onClick={() => setDisplayKpiViewer(true)}>
        View KPIs for this section
      </Button>
      <Dialog open={displayKpiViewer} onClose={handleCloseKpiViewer} maxWidth="lg" fullWidth fullScreen>
        <DialogContent>
          <AppBar sx={{ position: 'relative', borderRadius: '8px' }}>
            <Toolbar>
              <IconButton edge="start" color="inherit" onClick={handleCloseKpiViewer} aria-label="close">
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                KPIs for {questionnaireSection.name}
              </Typography>
              <Button autoFocus color="inherit" onClick={handleCloseKpiViewer}>
                Close
              </Button>
            </Toolbar>
          </AppBar>

          <KpiViewerForSectionMemo
            project={project}
            projectSections={projectSections}
            sectionId={questionnaireSection.id}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseKpiViewer}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
